<template>
    <div class="app-main" id="order-index">
        <el-row type="flex" class="app-main-header" align="middle">
            <el-col :span="6">
                <div class="router-title">
                    <i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{$route.meta.title}}</span>
                </div>
            </el-col>
        </el-row>
        <el-card class="box-card mg-b5">
            <div class="el-menu-box">
                <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect">
                    <el-menu-item
                        v-for="item in menus"
                        :key="item.key"
                        :index="item.key">
                            {{item.name}}
                            {{item.count?`(${item.count})`:''}}
                    </el-menu-item>
                </el-menu>
            </div>
        </el-card>
        <div class="order-wrap">
            <OrderTable  v-if="activeIndex == 'all'" pageFlag="all" />
            <OrderTable  v-if="activeIndex == 'waitRelease'" pageFlag="waitRelease" />
            <OrderTable  v-if="activeIndex == 'affirmIng'" pageFlag="affirmIng" />
            <OrderTable  v-if="activeIndex == 'affirmEnd'" pageFlag="affirmEnd" />
            <OrderTable  v-if="activeIndex == 'sendPlan'" pageFlag="sendPlan" />
            <OrderTable  v-if="activeIndex == 'signIn'" pageFlag="signIn" />
            <OrderTable  v-if="activeIndex == 'inStore'" pageFlag="inStore" />
            <OrderTable  v-if="activeIndex == 'invoice'" pageFlag="invoice" />
        </div>
    </div>
</template>
<script>
import OrderTable from '../OrderTable'
import { queryOrderStatic } from '@/api/omg/index.js';
export default {
    components:{
        OrderTable
    },
    created(){
        this.activeIndex = 'all'
        queryOrderStatic({}).then(({data:res}) => {
            if(res.code == 0){
                let curmenus = [...this.menus];
                let datas = res.data.statistics;
                datas.forEach(item => {
                    curmenus[item.code+1].count = item.count + ''
                })
                this.menus = [...curmenus]
            }
        })
    },
    data(){
        return {
            activeIndex:'',
            menus:[
                {key:'all',name:'全部',count:''},
                {key:'waitRelease',name:'待发布',count:''},
                {key:'affirmIng',name:'确认中',count:''},
                {key:'affirmEnd',name:'已确认',count:''},
                {key:'sendPlan',name:'送货计划',count:''},
                {key:'signIn',name:'已签收',count:''},
                {key:'inStore',name:'已入库',count:''},
                {key:'invoice',name:'已开票',count:''},
            ],
        }
    },
    methods:{
        handleSelect(key){
            this.activeIndex = key;
        },
    }
}
</script>
<style lang="scss">
    #order-index{
        .el-menu-box{
            width:100%;
        }
    }
</style>
